const PropTypes = require('prop-types');
const React = require('react');

const StorySummary = require('../news/brokerStorySummary');
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');

const {
    DATE_FORMAT_ES,
    DATE_FORMAT_SHORT_TIME_24,
    BROKER_MAX_MORE_PULSES
} = require('constants/index');
const DateHelper = require('utilities/dateHelper');
const { formatText } = require('core/i18n').i18n;

class MorePulses extends React.Component {
    buildContent() {
        const {
            immMarketsPulses,
            pageName
        } = this.props;
        const pulseData = immMarketsPulses.get('byOrder');
        const stories = pulseData.slice(1, BROKER_MAX_MORE_PULSES).map((pulseId, index) => {
            const immPulse = immMarketsPulses.getIn(['byId', pulseId]);
            const parsedDate = `${DateHelper.buildFormattedDate(immPulse.get('date'), DATE_FORMAT_ES)} - ${DateHelper.buildFormattedDate(immPulse.get('date'), DATE_FORMAT_SHORT_TIME_24)}`;
            const objId = `broker-news-pulse-${index}`;
            return (
                <OKLink modifier="emphasize" key={objId} className="broker-market-pulse" to={`/myprofile/broker/pulses/${immPulse.get('id')}`} tabIndex="-1">
                    <StorySummary
                        myDate={parsedDate}
                        title={immPulse.get('title')}
                        summary=""
                        readMore={false}
                        colorTitle="blue"
                        pageName={pageName}
                    />
                </OKLink>
            );
        });

        return stories;
    }

    render() {
        const {
            immMarketsPulses
        } = this.props;

        if (immMarketsPulses.get('isFetching')) {
            return (<LoadingSection />);
        }

        if (immMarketsPulses.get('error')) {
            return (<p>Ha ocurrido un error</p>);
        }

        const morePulses = this.buildContent();
        if (morePulses.size === 0) {
            const primaryText = formatText('broker-emptyPulses');
            return (
                <EmptyState
                    primaryText={primaryText}
                    iconType="noitems-wealth" />
            );
        } else {
            return (
                <div>
                    {morePulses}
                </div>
            );
        }
    }
}

MorePulses.propTypes = {
    immMarketsPulses: PropTypes.object.isRequired,
    requestMarketPulses: PropTypes.func.isRequired,
    pageName: PropTypes.string
}

module.exports = MorePulses;
